import { DocumentIdReducer } from './document-id.reducer';
import * as DocumentIdActions from './document-id.actions';

export { DocumentIdReducer, DocumentIdActions };
export * from './document-id.effects';
export * from './document-id.selectors';
